import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { editQuestionnaire } from 'Consts/Questionnaire';
import ShadowBox from 'Components/UI/ShadowBox';
import Content from '../UI/Content';
import PCInsurance from '../UI/RiskManagement/PCInsurance';
import HealthInsurance from '../UI/RiskManagement/HealthInsurance';
import LifeInsurance from '../UI/RiskManagement/LifeInsurance';
import '../UI/RiskManagement/index.css';

const RiskManagement = ({
  PCInsurancePolicies,
  medicareInsurancePolicies,
  healthSavingsAccounts,
  flexibleSpendingAccounts,
  privateHealthInsurancePolicies,
  shortTermDisabilityInsurancePolicies,
  longTermDisabilityInsurancePolicies,
  privateDisabilityInsurancePolicies,
  longTermCareInsurancePolicies,
  lifeInsuranceAccounts,
  groupLifeInsuranceAccounts,
  isAgent,
}) => {
  const simpleHousehold = useSimpleHousehold();
  function getEditLink(page, section) {
    if (simpleHousehold.householdResource) {
      return editQuestionnaire(page, {
        section,
        isAgent,
        householdId: simpleHousehold.householdResource.id(),
      });
    }
    return null;
  }

  return (
    <Fragment>
      <Content>
        <ShadowBox>
          <table className="pc-etc">
            <tbody>
              {/*
              |--------------------------------------------------------------------------
              | PC Insurance
              |--------------------------------------------------------------------------
              */}
              <PCInsurance
                PCInsurancePolicies={PCInsurancePolicies}
                editLink={getEditLink('insurance', '')}
              />
              <HealthInsurance
                medicareInsurancePolicies={medicareInsurancePolicies}
                healthSavingsAccounts={healthSavingsAccounts}
                flexibleSpendingAccounts={flexibleSpendingAccounts}
                privateHealthInsurancePolicies={privateHealthInsurancePolicies}
                shortTermDisabilityInsurancePolicies={
                shortTermDisabilityInsurancePolicies
              }
                longTermDisabilityInsurancePolicies={
                longTermDisabilityInsurancePolicies
              }
                privateDisabilityInsurancePolicies={
                privateDisabilityInsurancePolicies
              }
                longTermCareInsurancePolicies={longTermCareInsurancePolicies}
                editLink={getEditLink('insurance', '')}
                groupHealthInsuranceDetails={simpleHousehold?.householdResource?.attr('groupHealthInsuranceDetails')}
              />
            </tbody>
          </table>
        </ShadowBox>
      </Content>
      <LifeInsurance
        lifeInsuranceAccounts={lifeInsuranceAccounts}
        groupLifeInsuranceAccounts={groupLifeInsuranceAccounts}
        editLink={getEditLink('insurance', '')}
      />
    </Fragment>
  );
};

RiskManagement.propTypes = {
  PCInsurancePolicies: PropTypes.array.isRequired,
  medicareInsurancePolicies: PropTypes.array.isRequired,
  healthSavingsAccounts: PropTypes.array.isRequired,
  flexibleSpendingAccounts: PropTypes.array.isRequired,
  privateHealthInsurancePolicies: PropTypes.array.isRequired,
  shortTermDisabilityInsurancePolicies: PropTypes.array.isRequired,
  longTermDisabilityInsurancePolicies: PropTypes.array.isRequired,
  privateDisabilityInsurancePolicies: PropTypes.array.isRequired,
  longTermCareInsurancePolicies: PropTypes.array.isRequired,
  lifeInsuranceAccounts: PropTypes.array.isRequired,
  groupLifeInsuranceAccounts: PropTypes.array.isRequired,
  isAgent: PropTypes.bool.isRequired,
};

export default RiskManagement;
